import {Injectable} from '@angular/core';
import {
  HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse,
  HttpSentEvent, HttpUserEvent
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/internal/operators';
import {AuthorizationService} from '../modules/shared/service/authorization.service';
import {Router} from '@angular/router';
import {LoggerService} from '../service/logger.service';
import {environment} from '../../environments/environment';
import {EnvironmentType} from '../modules/shared/enums/enums';
import {HttpHeadersService} from '../modules/shared/service/http-headers.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private logger: LoggerService, private router: Router, private authorizationService: AuthorizationService,
              private headersService: HttpHeadersService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if (this.authorizationService.doesTokenExist()) {
      req = this.ifOnLocalCloneRequestWithTokensInHeaders(req);
      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            switch ((<HttpErrorResponse>error).status) {
              case 401:
              case 403:
                window.location.href = environment.accountSiteUrl + 'login?application=Residenz&redirectUrl=' + window.location.href;
                return of(null);
                break;
              default:
                this.logError(error, req);
                return throwError(error);
            }
          } else {
            return next.handle(req);
          }
        })
      );
    } else {
      return next.handle(req);
    }
  }

  private logError(error, req) {
    const showModal = !this.headersService.hasNoModalHeader(req);
    const logError = !this.headersService.hasNoLogHeader(req);
    if (logError) {
      this.logger.httpRequestError(error.status, req.method, req.urlWithParams, JSON.stringify(req.body), showModal);
    }
  }

  private ifOnLocalCloneRequestWithTokensInHeaders(req: HttpRequest<any>): HttpRequest<any> {
    if (environment.name === EnvironmentType.LOCAL) {
      return req.clone({
        setHeaders: {
          'jwt': this.authorizationService.getToken(),
          'refreshtoken': this.authorizationService.getRefreshToken(),
        }
      });
    } else {
      return req;
    }
  }
}
